(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nly-avis-compact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReviews(root) {
    if (!root || root.dataset.nlyReviewsReady === 'true') return;
    root.dataset.nlyReviewsReady = 'true';

    var rail = root.querySelector('[data-nly-review-rail]');
    var progress = root.querySelector('[data-nly-review-progress]');
    if (!rail || !progress) return;

    function paint() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var cards = rail.children.length || 1;
      var ratio = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
      var start = 1 / cards;
      progress.style.transform = 'scaleX(' + Math.min(1, start + ratio * (1 - start)) + ')';
    }

    rail.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.nly-reviews').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nly-cerise-geste"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nlyCeriseReady === 'true') return;
    root.dataset.nlyCeriseReady = 'true';

    var rail = root.querySelector('[data-nly-cerise-rail]');
    var progress = root.querySelector('[data-nly-cerise-progress]');
    if (!rail || !progress) return;

    function paint() {
      var max = rail.scrollWidth - rail.clientWidth;
      var count = rail.children.length || 1;
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      var start = 1 / count;
      progress.style.transform = 'scaleX(' + Math.min(1, start + ratio * (1 - start)) + ')';
    }

    rail.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-nly-cerise-steps]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nly-faq-compact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    if (!root || root.dataset.nlyFaqReady === 'true') return;
    root.dataset.nlyFaqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-nly-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nly-product-achat"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBuy(root) {
    if (!root || root.dataset.nlyReady === 'true') return;
    root.dataset.nlyReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nly-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nly-thumb]'));
    var rail = root.querySelector('[data-nly-gallery-rail]');
    var progress = root.querySelector('[data-nly-progress]');

    function showSlide(index) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.nlySlide === index);
      });
      thumbs.forEach(function (thumb) {
        var active = thumb.dataset.nlyThumb === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(thumb.dataset.nlyThumb);
      });
    });

    function paintProgress() {
      if (!rail || !progress || !slides.length) return;
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var ratio = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
      var start = 1 / slides.length;
      progress.style.transform = 'scaleX(' + Math.min(1, start + ratio * (1 - start)) + ')';
    }

    if (rail) {
      rail.addEventListener('scroll', paintProgress, { passive: true });
      paintProgress();
    }

    var hiddenInput = root.querySelector('input[name="id"]');
    var submit = root.querySelector('.nly-product-buy__submit');
    var submitText = root.querySelector('[data-nly-submit-text]');
    var variantButtons = Array.prototype.slice.call(root.querySelectorAll('[data-nly-variant]'));

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        variantButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (hiddenInput) {
          hiddenInput.value = button.dataset.variantId;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var available = button.dataset.available === 'true';
        if (submit) {
          submit.disabled = !available;
          submit.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
        if (submitText) {
          submitText.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
        }
      });
    });
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-nly-buy]').forEach(initBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
